/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

export const ClassesValidator = Yup.object({
  name: Yup.string().max(255).required('Class name is required'),
  grade: Yup.string().max(255).required('Grade name is required')
});
